import { extendObservable, action, toJS } from 'mobx';

import DashboardApi from '../psuite-js/apis/delivery/dashboard';

class DashboardStore {

    constructor() {
        extendObservable(this, {
            vehicles: [],

            fetching: false,
            updated_at: null,
            time_to_sync: 10000,

            is_fetched: false,
            fetch: action(this.fetch.bind(this)),
            getItems: action(this.getItems.bind(this)),
        });
    }


    async fetch() {
        this.fetching = true;

        const response = await DashboardApi.all();

        if (response.status === 200) {
            this.updated_at = response.data.updated_at;
            this.vehicles = response.data.data;
            this.is_fetched = true;
        }

        this.fetching = false;
        return response;
    }

    getItems() {

        if (!this.vehicles.length) {
            return {
                on_route: [],
                loading: [],
                delivery_process: []
            }
        }

        return toJS(this.vehicles);
    }

    getItemsLoading() {
        return toJS(this.vehicles.loading);
    }

    getItemsOnRoute() {
        return toJS(this.vehicles.on_route);
    }

    getItemsDeliveryProcess() {
        return toJS(this.vehicles.delivery_process);
    }

}

export default new DashboardStore();



// WEBPACK FOOTER //
// ./src/stores/dashboard.js